import {
  lucideArrowLeft,
  lucideCalendar,
  lucideCamera,
  lucideCheck,
  lucideChevronDown,
  lucideCircleAlert,
  lucideCircleCheck,
  lucideEye,
  lucideEyeOff,
  lucideFileText,
  lucideGlobe,
  lucideHandCoins,
  lucideInfo,
  lucideKeyRound,
  lucideLockKeyhole,
  lucideMail,
  lucideMailCheck,
  lucidePhone,
  lucideRefreshCw,
  lucideStar,
  lucideUserCheck,
  lucideX,
  lucideGift,
  lucidePackageOpen,
} from '@ng-icons/lucide';

export const ICONS_MAP = {
  lucideArrowLeft,
  lucideCalendar,
  lucideCamera,
  lucideCheck,
  lucideChevronDown,
  lucideCircleAlert,
  lucideCircleCheck,
  lucideEye,
  lucideEyeOff,
  lucideFileText,
  lucideGlobe,
  lucideHandCoins,
  lucideInfo,
  lucideKeyRound,
  lucideLockKeyhole,
  lucideMail,
  lucideMailCheck,
  lucidePhone,
  lucideRefreshCw,
  lucideStar,
  lucideUserCheck,
  lucideX,
  lucideGift,
  lucidePackageOpen,
};

type LucideIcon = keyof typeof ICONS_MAP;

export const ICONS_NAME_MAP = {
  'arrow-left': 'lucideArrowLeft',
  calendar: 'lucideCalendar',
  camera: 'lucideCamera',
  check: 'lucideCheck',
  'chevron-down': 'lucideChevronDown',
  'circle-alert': 'lucideCircleAlert',
  'circle-check': 'lucideCircleCheck',
  email: 'lucideMail',
  'eye-off': 'lucideEyeOff',
  eye: 'lucideEye',
  'file-text': 'lucideFileText',
  info: 'lucideInfo',
  'key-round': 'lucideKeyRound',
  'lock-keyhole': 'lucideLockKeyhole',
  'mail-check': 'lucideMailCheck',
  phone: 'lucidePhone',
  'refresh-cw': 'lucideRefreshCw',
  star: 'lucideStar',
  'user-check': 'lucideUserCheck',
  website: 'lucideGlobe',
  x: 'lucideX',
  'hand-coins': 'lucideHandCoins',
  gift: 'lucideGift',
  'package-open': 'lucidePackageOpen',
} satisfies Record<string, LucideIcon>;

export type IconName = keyof typeof ICONS_NAME_MAP;
